export const FILE_TYPE_SETTINGS_TITLE_ID = 'file-type-settings-title';
export const FILE_TYPE_DESCRIPTION_ID = 'file-type-settings-description';

export const FILE_TYPE_OPTION = {
	HTML: 'html',
	PDF: 'pdf'
} as const;

export type FileTypeOption = (typeof FILE_TYPE_OPTION)[keyof typeof FILE_TYPE_OPTION];

const CONTENT_TYPES: Record<FileTypeOption, string[]> = {
	[FILE_TYPE_OPTION.HTML]: ['text/html', 'text/plain'],
	[FILE_TYPE_OPTION.PDF]: ['application/pdf']
};

export const toContentTypes = (option: FileTypeOption): string[] => CONTENT_TYPES[option];

export const RADIO_OPTIONS_CONFIG = [
	{ label: 'HTML', value: FILE_TYPE_OPTION.HTML },
	{ label: 'PDF', value: FILE_TYPE_OPTION.PDF }
] as const;
